module.exports = __webpack_public_path__ + "assets/img/img175.dd33485a.png";